import { Action, ActionType } from "@redux/actionTypes/apiCommercialActionType";
import { Reducer } from "react";

export interface IAPICommercialListState {
  apiCommercialsDetailsByPID: ProjectAPICommercialsForm[];
  apiCommercialPreviewDetails: PreviewDeatisData[];
}

export interface ProjectAPICommercialsForm {
  projectId: number;
  projectName: string;
  apiRate: string;
  currencyId: number;
  isBdCommercialDataExist?: boolean;
  apiCommercialType: string;
  apiCommercialsTable: APICommercialInterface[];
}

export interface APICommercialInterface {
  apiCommercialId?: number;
  businessUnitId: string;
  countryId: number;
  apiName: string;
  currencyId?: number 
  apiMarketDetail: {
    marketDetailId?: number;
    apicommercialId?: number;
    marketVolume: number;
    marketValue: number;
    marketSp: number;
    marketVGrowth: number;
    noOfCompetitor: number;
  };
  apiMarketShareEstimate: {
    marketShareEstimateId?: number;
    apicommercialId?: number;
    high: number;
    mid: number;
    low: number;
  };
  apiMarketPriceAdjustment: {
    marketPriceAdjId?: number;
    apicommercialId?: number;
    high: number;
    mid: number;
    low: number;
    erosion: number;
  };
  apiMarketShareSelection: {
    marketShareSelectionId?: number;
    apicommercialId?: number;
    year1: string;
    year2: string;
    year3: string;
    year4: string;
    year5: string;
  };
  apiMarketPriceAdjSelection: {
    mpadjSelectioId?: number;
    apicommercialId?: number;
    year1: string;
    year2: string;
    year3: string;
    year4: string;
    year5: string;
  };
  marketVolumesInKg?: {
    year1: string;
    year2: string;
    year3: string;
    year4: string;
    year5: string;
  };
  estimatedMarektSP?: {
    year1: string;
    year2: string;
    year3: string;
    year4: string;
    year5: string;
  };
  apiSimplifiedMarketPriceAdj: {
    marketPriceAdjId?: number;
    apicommercialId?: number;
    year1: number;
    year2: number;
    year3: number;
    year4: number;
    year5: number;
    erosion: number;
  };
  apiSimplifiedMarketShareEstimate: {
    marketShareEstimateId?: number;
    apicommercialId?: number;
    year1: number;
    year2: number;
    year3: number;
    year4: number;
    year5: number;
  };

}

export interface PreviewDeatisData {
  salesTable: SalesTable[];
  captive: TableRow[];
  capativeConsumption: TableRow[];
  totalAPIRequirement: TableRow[];
}
export interface SalesTable {
  sales: TableRow[];
  thirdPartySales: TableRow[];
}
export interface TableRow {
  businessUnit: string;
  country: string;
  apiName: string;
  isBold: boolean;
  order: number;
  columnValue: number;
  year1: number;
  year2: number;
  year3: number;
  year4: number;
  year5: number;
}

const initialState = {
  apiCommercialsDetailsByPID: [],
  apiCommercialPreviewDetails: [],
};

export const apiCommercialReducer: Reducer<IAPICommercialListState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.API_COMMERCIAL_DETAIL_BY_PID:
      return {
        ...state,
        apiCommercialsDetailsByPID: action.payload,
      };
    case ActionType.API_COMMERCIAL_PREVIEW_DETAILS_DATA:
      return {
        ...state,
        apiCommercialPreviewDetails: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
